import { render } from "./ReserveWarning.vue?vue&type=template&id=26cc2dee"
import script from "./ReserveWarning.vue?vue&type=script&lang=js"
export * from "./ReserveWarning.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__